module.exports = __webpack_public_path__ + "img/gys_25@2x.e1d324d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_25@2x.png
// module id = FBLY
// module chunks = 0